'use client';
import Image from "next/image";
import { useRouter } from 'next/navigation';
import { useTranslations } from "next-intl";
import useFetchPosts from "@/components/post/fetcher";
import { useLocale } from "next-intl";
import Link from "next/link";

const NewsSection = () => {
  const t = useTranslations('NewsSection');
  const l = useLocale();
  const router = useRouter();
  const { posts, error, isLoading } = useFetchPosts();
  
  const getLocalizedField = (item: any, field: string) => item[`${field}_${l}`] || item[`${field}_en`];
  
  // Skeleton Loading Component
  const SkeletonLoader = () => (
    <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 px-4 py-16 bg-neutral">
      {Array.from({ length: 6 }).map((_, index) => (
        <div
          key={index}
          className="h-96 w-full relative bg-gray-300 animate-pulse rounded-lg"
        >
          <div className="absolute bottom-4 mx-4 px-1">
            <div className="h-6 bg-gray-400 animate-pulse w-3/4 rounded-md"></div>
          </div>
        </div>
      ))}
    </div>
  );
  
  return (
    <section className="w-full" aria-labelledby="news-section-heading">

      {isLoading ? (
        <SkeletonLoader />
      ) : error ? (
        <SkeletonLoader />
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 px-4 py-16 cursor-pointer bg-black">
          {posts.slice(0, 6).map((item) => (
            <div  key={item.id}>
            <Link href={`/${l}/blog/` + getLocalizedField(item, "url")}>
            <div 
              className="h-60 lg:h-80 w-full relative rounded-lg overflow-hidden group">
              {/* Parallax Container */} 
              <div className="absolute inset-0 overflow-hidden">
               
                <Image
                  src={`${process.env.NEXT_PUBLIC_IMAGE}/${getLocalizedField(item, "image")}`}
                  alt={getLocalizedField(item, "tag")}
                  sizes="100vw, 100vw"
                  fill
                  quality={85}
                  priority
                  style={{ 
                    objectFit: "cover",
                    transition: "transform 0.3s ease-out",
                    transform: "scale(1.1)"
                  }}
                  className="group-hover:scale-110 transition-transform duration-700 ease-out"
                  
                />
              </div>
              <div className="absolute inset-0 bg-black bg-opacity-30 group-hover:bg-opacity-20 transition-all duration-300"></div>
              <div className="absolute bottom-4 mx-4 px-1">
               
                  <h3 className="font-bold uppercase px-3 text-yel">
                    {getLocalizedField(item, "title").slice(0, 35)}{getLocalizedField(item, "title").length > 35 ? '...' : ''}
                  </h3>
                
              </div>
            </div></Link></div>
          ))}
        </div>
      )}
    </section>
  );
};

export default NewsSection;